import React from "react";
import "./VideoBanner.module.css";
import CustomLink from "../../components/CustomLink";

function VideoBanner(props) {

  return (
    <div className="VideoBanner">
        <h2>Стань сервисным инженером</h2>
        <div className="VideoBannerItems">
            <div className="VideoBannerItem">
                <iframe 
                    src="https://rutube.ru/play/embed/17c529b22c68837131b4850407ae68a2/" 
                    frameBorder="0" 
                    allow="clipboard-write; autoplay" 
                    webkitAllowFullScreen 
                    mozallowfullscreen 
                    allowFullScreen>
                </iframe>
            </div>
            <div className="VideoBannerItem">
                <iframe 
                    src="https://rutube.ru/play/embed/8d7a169ae993e418cea998269b53af3c/" 
                    frameBorder="0" 
                    allow="clipboard-write; autoplay" 
                    webkitAllowFullScreen 
                    mozallowfullscreen 
                    allowFullScreen>
                </iframe>
            </div>
            <div className="VideoBannerItem VideoBannerItem--last">
                <iframe 
                    src="https://rutube.ru/play/embed/7f48c5a0c56782678fd3fd324c3e2ab1/" 
                    frameBorder="0" 
                    allow="clipboard-write; autoplay" 
                    webkitAllowFullScreen 
                    mozallowfullscreen 
                    allowFullScreen>                        
                </iframe>
            </div>
        </div>
    </div>
  );
}

export default VideoBanner;



// WEBPACK FOOTER //
// ./src/components/VideoBanner/index.js